import * as yup from "yup";
import {Client, CreateAdvancePaymentRequest} from "../../../lib/types/types";

export const validationSchema: yup.SchemaOf<CreateAdvancePaymentRequest> = yup.object({
    clientId: yup.number().positive().required(),
    date: yup.date().required(),
    amount: yup.number().positive().required(),
})
